// extracted by mini-css-extract-plugin
module.exports = {"container":"_3rQStaVNptXTNOlO","partner":"_2R4WKtCaazdmd7BX"};